<template>
  <side :menu="sidebar_items" width="200px" :notification="notification" :collapsed="hide" showOneChild>
      <template #dropdown-icon-closed>
        <img src="../assets/icons/add.svg" alt="">
      </template>
      <template #dropdown-icon-open>
        <img src="../assets/icons/minus.svg" alt="">
      </template>
    </side>
</template>

<script>
import side from './sidebar/index'
import echo from '../socket'

export default {
    name: "sidebar",
    components:{side},
    props: {
      hide: {
        type: Boolean,
        default: false
      },
      notification: {
        type: Boolean,
        default: false
      }
    },
    data: ()=> ({
      key: 1,
      sidebar_items: [
        {
          id: 1,
          title: 'Главная',
          icon: 'main',
          setting: require('../assets/icons/setting.svg'),
          href: '/main',
          permission: ''
        },
        // {
        //   id: 2,
        //   title: 'Продажи',
        //   icon: 'salies',
        //   href: '/xxx',
        // },
        // {
        //   title: 'Закупки',
        //   icon: 'purchases',
        //   setting: require('../assets/icons/add.svg'),
        //   showChild: true,
        //   child:[
        //     {
        //       title: 'Форма заказа',
        //       href:'/order',
        //     },
        //     {
        //       title: 'Мои заказы',
        //       href: localStorage.getItem('type') == 1 ? '/provider-orders' : '/purchaser-orders',
        //     },
        //   ]
        // },
        {
          title: 'Форма заказа',
          icon: 'purchases',
          href: '/order',
          permission: ''
        },
        {
          title: 'Мои заказы',
          icon: 'purchases',
          href: localStorage.getItem('type') == 1 ? '/provider-orders' : '/purchaser-orders',
          permission: ''
        },
        {
          title: localStorage.getItem('type') == 1 ? 'Мои товары' : 'Каталог всех товаров',
          icon: 'products',
          href: localStorage.getItem('type') == 1 ? '/myitems' : '/items',
          setting: require('../assets/icons/add.svg'),
          permission: ''
        },
        // {
        //   id: 5,
        //   title: 'Логистика',
        //   icon: 'logistics',
        //   href: '/xxx',
        // },
        // {
        //   id: 6,
        //   title: 'Предложения',
        //   icon: 'suggestions',
        //   href: '/xxx',
        //   setting: require('../assets/icons/add.svg')
        // },
        {
          title: 'Чаты',
          icon: 'chat',
          href: '/chat',
          news: null,
          permission: ''
        },
        {
          title: 'Сотрудники',
          icon: 'staff',
          href: '/users',
          permission: 'page.users'
        },
        {
          title: 'Магазины',
          icon: 'shops',
          href: '/shops',
          permission: ''
        },
        // {
        //   id: 9,
        //   title: 'Магазин',
        //   icon: 'mag',
        //   href: '/xxx',
        //   setting: require('../assets/icons/setting.svg')
        // },
        {
          title: localStorage.getItem('type') == 1 ? 'Мои клиенты' : 'Поставщики',
          icon: 'staff',
          href: '/partners',
          permission: 'page.partners'
        },
        {
          title: 'Мои договоры',
          icon: 'staff',
          href: '/contracts',
          permission: '',
          news: null
        },
        {
          id: 10,
          title: 'Дискуссионный клуб',
          icon: 'blog',
          href: '/blog',
          permission: ''

        },
        {
          title: 'КП',
          icon: 'offer',
          href: '/offers',
          permission: ''
        },
        {
          title: 'Дропшиппинг',
          icon: 'products',
          href: '/dropshipping',
          permission: 'page.dropshipping.permission'
        },
        {
          title: 'Заказы Дроп',
          icon: 'purchases',
          href: localStorage.getItem('type') == 1 ? '/dropshipping-provider-orders' : '/dropshipping-purchaser-orders',
          permission: 'page.dropshipping.permission'
        },
        {
          title: 'Логи импорта',
          icon: 'offer',
          href: '/import-logs',
          permission: ''
        },
        {
          title: 'Заметки',
          icon: 'notepad',
          href: '/notes',
          permission: ''
        }
      ]
    }),
    mounted() {
        this.logoutUser();
        this.getCountChatMess();
        this.getNewMessages();
        this.getCountContractsInvites();
        this.filter();
    },
    methods: {
        filter () {
          for (const key in this.sidebar_items) {
            if (!this.can(this.sidebar_items[key].permission)) {
              this.sidebar_items.splice(key, 1);
            }

            if (!this.$store.getters.getCompany.dropshipping && (this.sidebar_items[key].href == '/dropshipping-provider-orders' || this.sidebar_items[key].href == '/dropshipping-purchaser-orders')) {
                this.sidebar_items.splice(key, 1);
            }

            if (localStorage.getItem('type') != 1 && this.sidebar_items[key].href == '/import-logs') {
                this.sidebar_items.splice(key, 1);
            }
          }
        },
        redirect(name) {
          if(name.length > 0)
            this.$router.push({name});
        },
        getCountChatMess() {
          if (localStorage.getItem('token')) {
            this.$http.post('/get-count-chat-messages', {
              token: localStorage.getItem('token')
            }).then(({data}) => {
              if (data.chats_count) {
                if (this.$route.name != 'chat') {
                  for (const key in this.sidebar_items) {
                    if (this.sidebar_items[key].href == '/chat') {
                      this.sidebar_items[key].news = data.chats_count
                    }
                  }
                } else {
                  for (const key in this.sidebar_items) {
                    if (this.sidebar_items[key].href == '/chat') {
                      this.sidebar_items[key].news = null;
                    }
                  }
                }
              }
            }).catch((error) => {
                console.log(error)
            })
          }
        },
        getNewMessages() {
          if (localStorage.getItem('token')) {
            echo.private('chat.' + localStorage.getItem('token'))
              .listen('.new.message', () => {
                if (this.$route.name != 'chat') {
                  for (const key in this.sidebar_items) {
                    if (this.sidebar_items[key].href == '/chat') {
                      this.sidebar_items[key].news = true;
                    }
                  }
                } else {
                  for (const key in this.sidebar_items) {
                    if (this.sidebar_items[key].href == '/chat') {
                      this.sidebar_items[key].news = null;
                    }
                  }
                }
              });
          }
        },
        getCountContractsInvites() {
          if (localStorage.getItem('token')) {
            this.$http.post('/get-count-contract-invites', {
              token: localStorage.getItem('token')
            }).then(({data}) => {
              if (data.contracts) {
                if (this.$route.name != 'contracts') {
                  for (const key in this.sidebar_items) {
                    if (this.sidebar_items[key].href == '/contracts') {
                      this.sidebar_items[key].news = data.contracts
                    }
                  }
                } else {
                  for (const key in this.sidebar_items) {
                    if (this.sidebar_items[key].href == '/contracts') {
                      this.sidebar_items[key].news = null;
                    }
                  }
                }
              }
            }).catch((error) => {
              console.log(error)
            })
          }
        },
        logoutUser() {
          if (localStorage.getItem('token')) {
            let admin = false;
            if (localStorage.getItem('admin')) {
                admin = true;
            }
            this.$http.post('/logout-user', {
              token: localStorage.getItem('token'),
              admin: admin
            }).then(({data}) => {
              if (data.logout) {
                localStorage.removeItem('token');
                localStorage.removeItem('type');
                this.$toast.warning('Внимание, сайт обновился! Для вступления в силу изменений вы будете разлогинены!');
                setTimeout(()=>{
                  location.reload();
                },5000)
              }
            }).catch((error) => {
              console.log(error)
            })
          }
        }
    },

}
</script>

<style scoped lang="scss">
</style>
